import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { SharedService } from '../../services/shared/shared.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
@Component({
  selector: 'zip-selector',
  templateUrl: './zip-code.component.html',
  styleUrls: ['./zip-code.component.scss']
})
export class ZipCodeComponent implements OnInit {

  @Input() label: any = 'Zip/Postal Code';
  @Input() isRequired: any = false;
  @Input() appearance: any = 'outline';
  @Input() customClass: any = 'col';
  @Input() model: any = '';
  @Input() placeholder: any = 'Enter Zip';
  @Input() search_canada: any = 0;
  @Input() not_found = 'No Result Found';
  @Input() defaultzip = {};
  @Input() disabled:any = false;
  @Input() value:any = '';
  @Input() t:any = '1';
  zipArray: any = [];
  loader: boolean = false;
  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger, static: true })
  autoComplete: MatAutocompleteTrigger;

  @Output() zipSelected = new EventEmitter();
  //@Output() removeZipCode = new EventEmitter();
  zipObj: any;

  constructor(
    public shareService: SharedService,
    public cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (this.defaultzip && this.defaultzip['zip']) {
      this.zipObj = this.defaultzip;
      this.zipArray = [this.defaultzip];
    }
    window.addEventListener('scroll', this.scrollEvent, true);
  }
  scrollEvent = (event: any): void => {
    // if (this.autoComplete.panelOpen)
    //   // this.autoComplete.closePanel();
    //   this.autoComplete.updatePosition();
  };

  getZip(value: any, search_canada?: any) {
    this.loader = true;
    if (value && (value.length < 4 || value.length > 6)) {
      this.loader = false;
      return false;
    }
    this.shareService.getZipcode({
      zipcode: value,
      hideLoader: true,
      search_canada: search_canada == 1 ? search_canada : 0
    }
    ).subscribe((data: any) => {
      if (data && data.is_error == 0) {
        this.zipArray = data.zip_info;
      } else {
        this.zipArray = [];
      }
      this.loader = false;
    })
  }

  onSelectZip(data: any) {
    this.zipObj = data;
    this.zipSelected.emit(data)
  }

  removeZipCode() {
    this.zipObj = '';
    this.model = '';
    this.zipSelected.emit('');
  }

  checkIfSelected(event) {
    if (!this.zipObj) {
      this.model = '';
    } else {
      if (this.zipObj.zip != this.model) {
        this.model = this.zipObj.zip;
      }
    }

    this.cd.detectChanges();
  }

  omit_special_char(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  inputEvent(e) {
    // if (e.target.value.length > 5) {
    //   return false;
    // }
    // return true
  }



}
